import type { EntityState } from '@reduxjs/toolkit';

import type { reportConfigurationsTypes } from '../report-configurations';

export const GENERATED_REPORTS_REDUCER_KEY = 'generatedReportsStore';
export type GENERATED_REPORTS_REDUCER_KEY = typeof GENERATED_REPORTS_REDUCER_KEY;

// columns can be by account, date-range, payee, tag, entity (e.g. business, client, project)
export type CellType = 'AMOUNT' | 'DATE' | 'PERCENTAGE' | 'QCS_ENTITY' | 'STRING';

export type ReportColumn = {
  id?: string;

  cellType?: CellType;

  isAggSum?: boolean;
} & (
  | {
      headerType: 'STRING';
      headerValue: {
        id: string;
        string: string;
      };
    }
  | {
      headerType: 'DATE_RANGE';
      headerValue: {
        startOn: string; // ISO Date
        endOn: string;
      };
    }
  | {
      headerType: 'QCS_ENTITY';
      headerValue: {
        qcs_entity: 'PAYEE' | 'TAG' | 'ACCOUNT' | 'BUSINESS';
        id: string;
        name?: string;
      };
    }
);

export type CellItem = {
  amount: number;
  amountOn: string;
  txnId: string;
  splitItemId?: string;
  paymentTxnId?: string;
};

export type ReportCell = {
  id?: string;
  columnId?: string;
  value?: string;
  items?: CellItem[];
};

export type ReportRow = {
  id?: string;
  name?: string;
  parentId?: string;
  entityId?: string;
  entityType?: string;
  childrenEntityIds?: string[];
  expectedSign?: 'POSITIVE' | 'NEGATIVE';
  cellData: ReportCell[];
  other: boolean;
};

export type Report = {
  configuration: reportConfigurationsTypes.ReportConfiguration;
  name: string;

  reportType: reportConfigurationsTypes.ReportType;
  reportSubType?: reportConfigurationsTypes.ReportSubType;
  persistentType?: reportConfigurationsTypes.PersistentType;

  // ISO Dates
  startOn: string;
  endOn: string;

  total?: string;

  rowType?: reportConfigurationsTypes.RowType;
  columnType?: reportConfigurationsTypes.ColumnType;

  rows: ReportRow[];
  columns: ReportColumn[];
};

export type EntityValue = {
  location: string;
  isGenerating: boolean;

  report?: Report | null;
  error?: any;
};

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [GENERATED_REPORTS_REDUCER_KEY]: EntityState<EntityValue, string>;
  }
}
